<template>
  <div>
    <a-steps :current="current" v-if="!isfromCamp">
      <a-step :title="$t('Chooseplan')" />
      <a-step :title="$t('invoiceInformation')" />
      <a-step :title="$t('Payment')" />
    </a-steps>
    <a-steps :current="current" v-if="isfromCamp">
      <a-step :title="$t('CreateCampaign')" />
      <a-step :title="$t('Chooseplan')" />
      <a-step :title="$t('invoiceInformation')" />
      <a-step :title="$t('Payment')" />
    </a-steps>
  </div>
</template>
<script>
export default {
  props: ["current", "isfromCamp"],
  i18n: require("../i18n"),
};
</script>
